import { AccountSubtype } from "@common/constants/domains/accounting/accounts";
import { Form1099BoxFilterValue } from "@common/constants/domains/accounting/form1099Box";
import {
    AccountRolePresence,
    AccountRulePresence,
    AccountSource,
    AccountStatus,
} from "@common/types/domains/accounting/account";

export interface ChartOfAccountsViewFilters {
    entityId?: number;
    entityIds?: number[];
    accountStatus?: AccountStatus;
    accountSource?: AccountSource;
    accountRolePresence?: AccountRolePresence;
    accountRulePresence?: AccountRulePresence;
    accountSubtypes?: AccountSubtype[];
    form1099Boxes?: Form1099BoxFilterValue[];
    search?: string;
    coaTemplateGroupKeys?: string[];
}

export function getDisplayedEntityIds(
    filters: Pick<ChartOfAccountsViewFilters, "entityId" | "entityIds">,
): number[] | undefined {
    return (
        filters.entityIds ??
        (filters.entityId === undefined ? undefined : [filters.entityId])
    );
}
